module.exports = __webpack_public_path__ + "img/Komeda.0a061af4.svg";